import TimesheetCellModal from "pages/timesheets/components/timesheet-cell-modal"
import { useTaskDetailsModal } from "./task-details-modal"
import { useGetTaskQuery } from "@timenotes/shared/src/services/tasks/queries/use-get-task-query"
import moment from "moment-timezone"

interface Props {
  projectId?: string
  projectName?: string
  taskId?: string
  taskName?: string
}

export const TaskDetailsTimesheetModal = (props: Props) => {
  const {
  } = props

  const {
    taskId,
    projectId,
    timesheetVisible,
    closeTaskTimesheet,
  } = useTaskDetailsModal()

  const visible = !!projectId && !!taskId && timesheetVisible

  const { getTaskQuery } = useGetTaskQuery({
    projectId: projectId,
    taskId: taskId,
    options: {
      staleTime: Infinity,
    }
  })

  const task = getTaskQuery.data?.task

  const grouping = {
    primary: 'project',
    secondary: 'task',
  }

  const filters = {}

  const rounding = {
    type: 'no_rounding'
  }

  const row = {
    groupClass: 'Task',
    groupId: task?.id,
    groupHashId: task?.hashId,
    title: task?.name,
    totalWorktime: task?.worktime,
  }

  const parentRow = {
    groupClass: 'Project',
    groupId: task?.project.id,
    groupHashId: task?.project.hashId,
    title: task?.project.name,
  }

  // Prevents cell modal to fetch
  const cell = visible ? {
    //absences: [],
    date: moment().format(),
  } : null

  return (
    <TimesheetCellModal
      allTimeTotalFilter
      visible={visible}
      onCancel={closeTaskTimesheet}

      row={row}
      parentRow={parentRow}
      cell={cell}

      filters={filters}
      grouping={grouping}
      rounding={rounding}
    />
  )
}